import { apiInstance } from "@src/config/api";
import { PUBLIC_V1 } from "@src/constant/common";
import { objectToQueryParams } from "@src/helper/objectToQueryParams";

const api = apiInstance()

export const getListLocation = async (params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `${objectToQueryParams(params)}` : ""
  return api.get(`/${PUBLIC_V1}/module/portal/locations?${newParams}`)
}

export const getListProperty = async (params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `${objectToQueryParams(params)}` : ""
  return api.get(`/${PUBLIC_V1}/module/portal/properties?${newParams}`)
}

export const getListPropertyCompany = async (params = {}, slug) => {
  const newParams = (!!params && typeof params === "object") ? `${objectToQueryParams(params)}` : ""
  return api.get(`/${PUBLIC_V1}/module/portal/offices/${slug}/properties?${newParams}`)
}
